<div class="card border border-light-subtle bg-body-tertiary rounded h-100">
  <div class="card-body p-3 d-flex flex-column justify-content-between">
    <div>
      <h6 class="fw-bold mb-3 text-dark d-flex align-items-center">
        <i class="fas fa-calculator me-2 text-primary"></i>Resumen de Presupuestos
      </h6>

      @if (isTotalLoss()) {
        <div class="d-flex justify-content-between py-2 border-bottom text-muted claim-summary__row">
          <span>Valor Comercial Vehículo</span>
          <span class="fw-semibold text-dark">${{ (vehicleValue() ?? 0) | number:'1.0-0':'es-CL' }}</span>
        </div>
      } @else {
        <div class="d-flex justify-content-between py-2 border-bottom text-muted claim-summary__row">
          <span>Mano de Obra Acumulada</span>
          <span class="fw-semibold text-dark">${{ (laborCost() ?? 0) | number:'1.0-0':'es-CL' }}</span>
        </div>
        <div class="d-flex justify-content-between py-2 border-bottom text-muted claim-summary__row">
          <span>Repuestos / Pintura Acumulados</span>
          <span class="fw-semibold text-dark">${{ (partsCost() ?? 0) | number:'1.0-0':'es-CL' }}</span>
        </div>
      }

      @if (isNegligence() === true) {
        <div class="d-flex justify-content-between py-2 border-bottom text-muted claim-summary__row">
          <span>Negligencia</span>
          <span class="fw-semibold text-warning">Hay daño(s) negligente(s)</span>
        </div>
      } @else if (isNegligence() === false) {
        <div class="d-flex justify-content-between py-2 border-bottom text-muted claim-summary__row">
          <span>Negligencia</span>
          <span class="fw-semibold text-dark">No</span>
        </div>
      }

      <div class="d-flex justify-content-between align-items-center py-2 border-bottom bg-danger-subtle bg-opacity-25 px-2 my-2 rounded text-danger claim-summary__row">
        <span class="fw-semibold">{{ isTotalLoss() ? ('Retención ' + retentionPct() + '% (pérdida total)') : 'Total Deducible' }}</span>
        <span class="fw-bold">${{ (totalDeductible() ?? 0) | number:'1.0-0':'es-CL' }}</span>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
      <span class="fw-bold text-uppercase text-muted claim-summary__row">Total Bruto</span>
      <span class="fw-bold fs-5 text-muted">${{ (totalCost() ?? 0) | number:'1.0-0':'es-CL' }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center py-2 px-2 mt-2 rounded bg-success-subtle">
      <span class="fw-bold text-uppercase text-success claim-summary__row">Neto a Reembolsar</span>
      <span class="fw-bold fs-5 text-success">${{ (netReimbursement() ?? 0) | number:'1.0-0':'es-CL' }}</span>
    </div>
  </div>
</div>
